<template>
    <page>
        <module title="会员详情">

            <c-detail title="基本信息">
                <c-detail-item label="会员手机号">
                    {{baseInfo.user_manage_mobilephone}}
                </c-detail-item>
                <c-detail-item label="会员昵称">
					<span v-if="baseInfo.nick_name && baseInfo.nick_name!=''">
						{{baseInfo.nick_name}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="头像">
                    <c-image :src="baseInfo.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                </c-detail-item>
                <c-detail-item label="代理等级">
					<span v-if="baseInfo.user_level_name && baseInfo.user_level_name!=''">
						{{baseInfo.user_level_name}}
					</span>
                    <span v-else>普通会员</span>
                </c-detail-item>
                <c-detail-item label="成长值">
					<span v-if="baseInfo.growth_value">
						{{baseInfo.growth_value}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="成长等级">
					<span v-if="baseInfo.growth_level_name">
						{{baseInfo.growth_level_name}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="业绩数量">
                    {{baseInfo.performance_count}}<span style="color: darkgray">(已结算)</span>
                    <span v-if="baseInfo.unsettle_performance_count && baseInfo.unsettle_performance_count>0">
                        ;{{baseInfo.unsettle_performance_count}}<span style="color: darkgray">(待结算)</span>
                    </span>
                    <span v-if="baseInfo.user_level == -99 && baseInfo.upgrade_level_name">
						（可升级至：<span style="color: blue">{{baseInfo.upgrade_level_name}}</span>）
					</span>
                </c-detail-item>
                <c-detail-item label="(已结算)业绩金额">
                    ￥{{parseFloat(baseInfo.performance_money).toFixed(2)}}
                </c-detail-item>
                <c-detail-item label="货款余额(元)">
                    ￥{{parseFloat(baseInfo.account_balance).toFixed(2)}}
                </c-detail-item>
                <c-detail-item label="收益账户">
                    ￥{{parseFloat(baseInfo.reward_balance).toFixed(2)}}
                </c-detail-item>
                <c-detail-item label="积分">
                    {{baseInfo.points||0}}
                </c-detail-item>
                <c-detail-item label="会员状态">
                    <span v-if="baseInfo.state == 1" style="color:green">启用</span>
                    <span v-if="baseInfo.state == 2" style="color:red">禁用</span>
                    <span v-if="baseInfo.state == 3" style="color:blue">待审核</span>
                    <span v-if="baseInfo.state == 4" style="color:red">驳回</span>
                </c-detail-item>
                <c-detail-item label="注册时间">
                    {{baseInfo.create_date}}
                </c-detail-item>
                <c-detail-item label="注册来源">
                    {{userResourceMap[baseInfo.user_resource]}}
                </c-detail-item>
                <c-detail-item label="审核时间" v-if="baseInfo.state != 3 && systemConfig.user_register_check_enabled == 'ON'">
					<span v-if="baseInfo.approval_date && baseInfo.approval_date!=''">
						{{baseInfo.approval_date}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="审核人" v-if="baseInfo.state != 3 && systemConfig.user_register_check_enabled == 'ON'">
					<span v-if="baseInfo.approval_user_name && baseInfo.approval_user_name!=''">
						{{baseInfo.approval_user_name}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="驳回原因" v-if="baseInfo.state == 4 && systemConfig.user_register_check_enabled == 'ON'" full>
					<span v-if="baseInfo.rejected_reason && baseInfo.rejected_reason!=''">
						{{baseInfo.rejected_reason}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>
            </c-detail>
            <c-detail title="其他信息">
                <c-detail-item label="真实姓名">
					<span v-if="extraInfo.user_realname && extraInfo.user_realname!=''">
						{{extraInfo.user_realname}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>

                <c-detail-item label="性别">
					<span v-if="extraInfo.sex && extraInfo.sex!=''">
						{{extraInfo.sex}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>

                <c-detail-item label="生日">
					<span v-if="extraInfo.birthday && extraInfo.birthday!=''">
						{{extraInfo.birthday}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>

                <c-detail-item label="身高">
					<span v-if="extraInfo.height && extraInfo.height!=''">
						{{extraInfo.height}}（厘米）
					</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="体重">
					<span v-if="extraInfo.weight && extraInfo.weight!=''">
						{{extraInfo.weight}}（千克）
					</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="补全资料时间">
					<span v-if="extraInfo.create_date && extraInfo.create_date!=''">
						{{extraInfo.create_date}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>

                <c-detail-item label="健康与生活方式">
					<span v-if="extraInfo.life_mode_buffer && extraInfo.life_mode_buffer!=''">
						{{extraInfo.life_mode_buffer}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>
                <c-detail-item label="健康目标">
					<span v-if="extraInfo.health_goals_buffer && extraInfo.health_goals_buffer!=''">
						{{extraInfo.health_goals_buffer}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>

            </c-detail>

            <template slot="button">
                <c-button size="m" v-if="baseInfo.state == 3" @click="applyHandle(1)">审核通过</c-button>
                <c-button size="m" v-if="baseInfo.state == 3" color="red" @click="applyHandle(4)">审核驳回</c-button>
                <!--				<c-button size="m" @click="closeCurrPage()">关闭</c-button>-->
            </template>
        </module>

        <c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="rejectHandle">
            <div class="approval-eason">
                <textarea v-model="approvalReason" placeholder="请输入驳回理由..."></textarea>
            </div>
        </c-dialog>
    </page>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: 'member_detail',

    props: {
        platform_user_id: String
    },

    data() {
        return {
            baseInfo: {},
            extraInfo: {},
            approvalReason: '',
            userResourceMap: {
                'PC': 'PC',
                'OMS': '管理后台',
                'IOS': '苹果APP',
                'ANDROID': '安卓APP',
                'MINI': '微信小程序',
                'BARGAIN': '砍价页',
                'H5': 'H5页'
            }
        }
    },

    computed: {
        ...mapState(['systemConfig']),
    },

    watch: {
        platform_user_id() {
            this.getPlatformUserDetail();
        },
    },

    mounted() {
        this.getPlatformUserDetail();
    },

    methods: {
        getPlatformUserDetail() {
            this.request({
                url: '/platform_user/detail',
                data: {
                    platform_user_id: this.platform_user_id
                },
                loading: true,
                success: data => {
                    this.baseInfo = data.baseInfo;
                    this.extraInfo = data.extraInfo;
                }
            });
        },
        applyHandle(state) {
            if(state == 4){
                this.$refs.approvalReason.open();
            }else{
                this.$confirm({
                    text: '确定要审批通过吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/platform_user/approval',
                            data: {
                                platform_user_id: this.platform_user_id,
                                state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '审核成功'
                                });
                                this.getPlatformUserDetail();
                                this.$bus.$emit('platformApplyList.update');
                                this.redirectTo('/member_apply_list');
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            }


        },
        rejectHandle(stop){
            if (!this.approvalReason.trim()) {
                this.$message({
                    text: '请填写驳回原因'
                });
                stop();
                return;
            }
            this.request({
                url: '/platform_user/approval',
                data: {platform_user_id:this.platform_user_id,state:4,rejected_reason:this.approvalReason.trim()},
                loading: true,
                success: data => {
                    this.$message({
                        text: '驳回成功',
                        icon: 'success'
                    });
                    this.getPlatformUserDetail();
                    this.$bus.$emit('platformApplyList.update');
                    this.redirectTo('/member_apply_list');
                }
            });
        },
        closeCurrPage() {
            if(this.baseInfo.state == 3 || this.baseInfo.state == 4){
                this.redirectTo('/member_apply_list');
            }else{
                this.redirectTo('/member_list');
            }
        }
    }
}
</script>
<style lang="stylus" scoped>
.approval-eason {
    padding: 20px;

    textarea {
        box-sizing: border-box;
        width: 100%;
        height: 120px;
        border: none;
        padding: 10px 14px;
        line-height: 20px;
        background: #FAFAFA;
        resize: none;
    }
}
</style>